export function currentPosts(tmp, curPage, postsPerPage) {
  const last = curPage * postsPerPage;
  const first = last - postsPerPage;
  let cur = 0;
  if (tmp) {
    cur = tmp.slice(first, last);
  }
  return cur;
}
